import { render, staticRenderFns } from "./cakeOrder.vue?vue&type=template&id=1ba57306&scoped=true"
import script from "./cakeOrder.vue?vue&type=script&lang=js"
export * from "./cakeOrder.vue?vue&type=script&lang=js"
import style0 from "./cakeOrder.vue?vue&type=style&index=0&id=1ba57306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba57306",
  null
  
)

export default component.exports